import * as Msal from 'msal';
import config from '../config';
import AuthAPIService from './AuthApiService'
import router from '../router'

// With a lot of help from ; https://stackoverflow.com/questions/52944052/creating-a-single-instance-of-a-class-within-a-vue-application 
// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-core/src/UserAgentApplication.ts

export default class AuthService {
  constructor() {
    this.setUpMicrosoftApp();
  }

  setUpMicrosoftApp() {
    this.isLoading = false;
    this.graphUrl = config.graphendpoint
    this.applicationConfig = {
      auth: {
          clientId: config.clientid,
          authority: config.authority,
          redirectUri: config.redirecturl,
          navigateToLoginRequestUrl: false,
      },
      cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
      },
      silentRequest: {
        scopes: config.graphscopes,
        loginHint: 'correo@anahuac.mx'
      },
      graphScopes: {
        scopes: config.graphscopes
      }
    };
    this.app = new Msal.UserAgentApplication(this.applicationConfig);
    this.app.handleRedirectCallback(async (error, response) => {
        this.isLoading = true;
        if (response) {    
          let accessToken;
          if(response.accessToken) {
            accessToken = response;
          } else {
            accessToken = await this.getGraphToken();
          }
          const apiService = new AuthAPIService(true);
          apiService.realizarAutenticacion(accessToken.accessToken)
          .then((userDetails) => {
              this.isLoading = false;
              localStorage.removeItem("waiting");
              if(userDetails.user == null) {
                router.push('/confirmar-datos');
                return;
              } else if (userDetails.user.perfil == 'Alumno') {
                window.location.href = '/eventos-anahuac';
              } else {
                const route = localStorage.getItem("lastRoute");
                if(route && (route == "/inicio" || route == "/login")) {
                  window.location.reload();
                } else {
                  router.push(route ?? '/inicio');
                }
              }
          });
        } 
        if (error) {
          this.isLoading = false;
          location.reload();
          console.log('error:');
          console.log(error);
        }
    });
  }

  // Core Functionality
  login() {
    this.app
    .acquireTokenRedirect(this.applicationConfig.silentRequest);
  }

  logoutSSO() {
    this.app._user = null
    this.app.logout()
    localStorage.clear();
  }


  // Graph Related
  async getGraphToken() {
    let user = this.getUser();

    if(user) {
      return await this.app.acquireTokenSilent({
        ...this.applicationConfig.silentRequest,
        sid: user ? user.sid : ''
      });
    }

    return await this.app
    .acquireTokenRedirect(this.applicationConfig.silentRequest);
  }

  async getSilentToken() {
    try {
      let user = this.getUser();

      if(user) {
        return this.app.acquireTokenSilent({
          ...this.applicationConfig.silentRequest,
          sid: user ? user.sid : ''
        }).then((value) => {
          return value;
        }).catch(error => {
          return null;
        });
      }
  
      return null;
    } catch (error) {
      return null;
    }
    
  }

  async acquireTokenRedirect() {
    return await this.app
    .acquireTokenRedirect(this.applicationConfig.silentRequest);
  }

  getGraphUserInfo(token) {
    const headers = new Headers({ Authorization: `Bearer ${token}` });
    const options = {
      headers
    };
    return fetch(`${this.graphUrl}`, options)
      .then(response => response.json())
      .catch(response => {
        throw new Error(response.text());
      });
  }

  // Utility
  getUser() {
    if(this.app)
    return this.app.getAccount();
  }
}


